const PB_TYPE_IMAGE = 'image';
const PB_TYPE_TEXTBLOCK = 'textblock';
const PB_TYPE_BANNER = 'banner';
const PB_TYPE_CAROUSEL = 'carousel';
export { PB_TYPE_IMAGE, PB_TYPE_BANNER, PB_TYPE_TEXTBLOCK, PB_TYPE_CAROUSEL };
//# sourceMappingURL=constants.js.map